import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { GET, GET_WARRANTY_BY_DATE } from '../../../../services';
import { convertDateInputToPayload } from '../../../../functions/convert';
export const useGetRegDate = ({ handleSubmit }) => {
  const [data, setData] = useState([]);
  const { mutate: onSearch, isPending } = useMutation({
    mutationFn: async (searchParamState) => {
      const { startDate, tel, fullname, customerCode } = searchParamState;
      const [startDateFrom, startDateTo] = startDate || ['', ''];
      const response = await GET(
        GET_WARRANTY_BY_DATE({
          tel: tel || '',
          fullname: fullname || '',
          customerCode: customerCode || '',
          startDate: convertDateInputToPayload(startDateFrom),
          endDate: convertDateInputToPayload(startDateTo),
        }),
      );
      return response.result.items || [];
    },
    onSuccess: (response) => {
      setData(response);
    },
  });
  const onFetch = () =>
    handleSubmit((values) => {
      return onSearch(values);
    })();
  return { dataSource: data, setData, onSearch, isLoading: isPending, onFetch };
};
